/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file buildCallbackExecutor internal helper function
 * @author Roland Scott
 * @module react-async-hook\internal\use-async\build-callback-executor
 */

import { IAsyncFunction } from "../";
import { ICallbackExecutor } from "../types";
import { IErrorHandler, ISuccessHandler } from "../../types";

/**
 * Build the function that will execute the callbacks upon success or failure
 * @param onFailure Failure callback
 * @param onSuccess Success callback
 */
export function buildCallbackExecutor<TAsync extends IAsyncFunction>(
	onFailure?: IErrorHandler<TAsync>,
	onSuccess?: ISuccessHandler<TAsync>,
): ICallbackExecutor<TAsync> {
	return (result, error, extras) => {
		if (error) {
			if (onFailure) {
				onFailure(error, extras);
			}
		} else {
			if (onSuccess) {
				onSuccess(result, extras);
			}
		}
	};
}
